// extracted by mini-css-extract-plugin
module.exports = {"totals":"DonationsTotal_totals__OMfYM","period":"DonationsTotal_period__8_fRS"};